import { Grid } from '@mui/material';
import { useContext } from 'react';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import InputConfig from '../../../../Components/InputConfig';
import SwitchInput from '../../../../Components/SwitchInput';

const SeqAdRequestSectionSplit = ({ keyData }) => {
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	return (
		<Grid
			container
			alignItems="center"
			spacing={6}
			sx={{ mb: '3rem', mt: '0rem', ml: '2rem', width: '91%' }}
		>
			<Grid item>
				<SwitchInput
					keyData={`${keyData}.enabled`}
					label="Enable Internal split"
					defaultChecked={rawConfig?.[keyData]?.enabled || false}
					object={rawConfig}
					updateObject={updateRawConfig}
					containerStyles={{ width: 'fit-content' }}
				/>
			</Grid>

			<Grid item>
				<InputConfig
					containerStyles={{ width: '26rem' }}
					label="Split Percentage"
					keyData={`${keyData}.splitPercentage`}
					inputType="number"
					object={rawConfig}
					updateObject={updateRawConfig}
					editable={!!rawConfig[`${keyData}.enabled`]}
					placeholder="0% - 100%"
					inputProps={{ min: 0, max: 100 }}
					onChangeCheck={(val) => val >= 0 && val <= 100}
				/>
			</Grid>
		</Grid>
	);
};

export default SeqAdRequestSectionSplit;
